import type {
  ShouldUpdateScrollArgs,
  WrapRootElementBrowserArgs,
} from "gatsby";
import React from "react";
import { StoreProvider } from "./src/context/store-context";

import "@fontsource/montserrat";
import "@fontsource/montserrat/400-italic.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/merriweather";
import "@fontsource/merriweather/300.css";
import "@fontsource/merriweather/700.css";
import "@fontsource/bebas-neue";
import "./src/css/index.css";

export const wrapRootElement = ({
  element,
}: WrapRootElementBrowserArgs): React.ReactElement => (
  <StoreProvider>{element}</StoreProvider>
);

export function shouldUpdateScroll({
  routerProps: { location },
}: ShouldUpdateScrollArgs) {
  const scrollToTopRoutes = ["/cx-insights-hub/"];

  if (scrollToTopRoutes.includes(location.pathname)) {
    return false;
  }
}
